// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_el-3";
export var flatBottomCorners = "_el-5";
export var productImage = "_el-0";
export var quantityContainer = "_el-2";
export var quantityHeader = "_el-6";
export var tooltip = "_el-1";
export var wrapAndEllipsesOverflow = "_el-4";